import AssistantFace from "@/components/AssistantFace";
import { Check, Dumbbell } from "lucide-react";
import { BRAND, Logo } from "@/components/landing/primitives";

/** Two-column auth layout: form on the left, Fitamingo photo panel on the right. */
export default function AuthShell({ title, subtitle, children, footer, variant = "coach" }) {
  return (
    <div className="flex min-h-dvh bg-white text-ink">
      <div className="flex flex-1 flex-col px-5 py-6 sm:px-10">
        <Logo />
        <main className="mx-auto flex w-full max-w-[400px] flex-1 flex-col justify-center py-10">
          <h1 className="text-[32px] font-medium leading-tight tracking-[-0.6px]">{title}</h1>
          {subtitle && <p className="mt-2 text-[15px] leading-6 text-neutral-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-neutral-500">{footer}</div>}
        </main>
        <p className="text-center text-xs text-neutral-400 sm:text-left">© {new Date().getFullYear()} Fitamingo</p>
      </div>

      <aside className="relative hidden w-[46%] max-w-[720px] overflow-hidden border-l border-line bg-soft lg:block">
        <img src={variant === "client" ? BRAND.martin : BRAND.nasim} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_20%]" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        <div className="absolute inset-x-8 bottom-8 flex flex-col gap-3 rounded-2xl bg-[#0A0A0A]/95 p-5 text-white shadow-2xl">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-lemon">
              {variant === "client" ? <Dumbbell className="h-4 w-4 text-black" strokeWidth={2.3} /> : <AssistantFace className="h-8 w-8" />}
            </span>
            <span className="text-[15px] leading-snug">
              {variant === "client" ? "Your plan for today is ready." : '"Remind me to check in with everyone who went quiet this week."'}
            </span>
          </div>
          <div className="h-px bg-neutral-800" />
          {(variant === "client"
            ? ["Lower body A, 6 exercises with video demos", "Meal plan: 1,900 kcal", "Check-in due Sunday"]
            : ["Found 3 quiet clients", "Drafted a friendly nudge for each", "Waiting for your approval"]
          ).map((t) => (
            <div key={t} className="flex items-center gap-2.5 text-sm text-neutral-200">
              <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-lemon">
                <Check className="h-[11px] w-[11px] text-black" strokeWidth={3} />
              </span>
              {t}
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
}
